import React, { useState } from 'react';
import './style.scss';
import guideImage from '../cedora-assets/mobile-user-guide.png';

function GuideButton() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // const togglePopup = () => {
  //   setIsPopupOpen(!isPopupOpen);
  // };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  };

  const handleDialogClick = (e) => {
    // Close dialog when clicking on backdrop (dialog element itself)
    if (e.target === e.currentTarget) {
      closePopup();
    }
  };

  return (
    <>
      <div
        className="guide-button"
        // onClick={togglePopup}
        type="button"
        aria-label="Open user guide"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_325_559)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.99998 1.83325C4.59422 1.83325 1.83331 4.59416 1.83331 7.99992C1.83331 11.4057 4.59422 14.1666 7.99998 14.1666C11.4057 14.1666 14.1666 11.4057 14.1666 7.99992C14.1666 4.59416 11.4057 1.83325 7.99998 1.83325ZM0.833313 7.99992C0.833313 4.04188 4.04194 0.833252 7.99998 0.833252C11.958 0.833252 15.1666 4.04188 15.1666 7.99992C15.1666 11.958 11.958 15.1666 7.99998 15.1666C4.04194 15.1666 0.833313 11.958 0.833313 7.99992ZM7.99998 5.16659C7.58577 5.16659 7.24998 5.50237 7.24998 5.91659C7.24998 6.19273 7.02612 6.41659 6.74998 6.41659C6.47384 6.41659 6.24998 6.19273 6.24998 5.91659C6.24998 4.95009 7.03348 4.16659 7.99998 4.16659C8.96648 4.16659 9.74998 4.95009 9.74998 5.91659C9.74998 6.55881 9.40375 7.11964 8.89015 7.4235C8.75899 7.5011 8.65071 7.58583 8.58017 7.66896C8.51168 7.74967 8.49998 7.80232 8.49998 7.83325V8.66659C8.49998 8.94273 8.27612 9.16659 7.99998 9.16659C7.72384 9.16659 7.49998 8.94273 7.49998 8.66659V7.83325C7.49998 7.49599 7.64763 7.22234 7.81771 7.02193C7.98573 6.82393 8.19524 6.67272 8.38096 6.56284C8.60294 6.43151 8.74998 6.19095 8.74998 5.91659C8.74998 5.50237 8.41419 5.16659 7.99998 5.16659ZM7.99998 11.3333C8.36817 11.3333 8.66665 11.0348 8.66665 10.6666C8.66665 10.2984 8.36817 9.99992 7.99998 9.99992C7.63179 9.99992 7.33331 10.2984 7.33331 10.6666C7.33331 11.0348 7.63179 11.3333 7.99998 11.3333Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_325_559">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      {isPopupOpen && (
        <dialog
          className="popup-overlay"
          onClick={handleDialogClick}
          onKeyDown={handleKeyDown}
          aria-modal="true"
          aria-labelledby="user-guide-title"
          open
        >
          <div className="popup-content">
            <button
              className="close-button"
              onClick={closePopup}
              aria-label="Close user guide"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 5L5 15M5 5L15 15"
                  stroke="#090A0B"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            <div className="popup-body">
              <h3 id="user-guide-title">User Guide</h3>
              <div className="guide-image">
                <img src={guideImage} alt="guide" />
              </div>
              <p className="guide-text">Click and drag to navigate around</p>
            </div>
          </div>
        </dialog>
      )}
    </>
  );
}

export default GuideButton;
